import { useState } from 'react';
import { filterFormItemLayout, filterFormGridLayout } from '@utils/property';
import { Form, Row, Col, Input, Select, DatePicker, Button, Space, Cascader, InputNumber } from 'antd';
const { RangePicker } = DatePicker;

export default function FormalOrganizationsInfoQueryFrom({ handleFilterFinish }) {
    const [form] = Form.useForm();

    const onFinish = values => {
        if (values) {
            handleFilterFinish(values);
        }
    };

    const [timePicker, setTimePicker] = useState([]);
    const handleChangeTime = (value, dateString) => {
        setTimePicker(dateString);
    };

    const onReset = () => {
        form.resetFields();
        const values = {
            //写 所有的筛选数据
            phone: undefined,
            name: undefined,
        };
        handleFilterFinish(values);
    };

    return (
        <div className="formalOrg-research">
            <Form {...filterFormItemLayout} onFinish={onFinish} form={form}>
                <Row>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="姓名" name="name">
                            <Input allowClear placeholder="姓名" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="手机号" name="phone">
                            <Input allowClear placeholder="手机号" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col className="filter-form-buttons" {...filterFormGridLayout}>
                        <Space>
                            <Button type="default" onClick={onReset}>
                                重置
                            </Button>
                            <Button type="primary" icon={<i className="bi bi-search"></i>} htmlType="submit">
                                检索
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
